import { i18n } from '@lingui/core'
import type { Locale } from 'date-fns'
import { enUS, es } from 'date-fns/locale'

/** The date-fns locale matching the active Lingui language. */
export const activeDateFnsLocale = (): Locale =>
  i18n.locale === 'es' ? es : enUS
